<template>
  <!-- Product title - mobile only -->
  <div class="product-title">
    <div
      class="
        product-title__title
        main-product__form-footer-action
        text-mobile-medium-mobile
        text-regular
      "
      v-text="product.title"
    />

    <div>
      <p
        v-if="comingSoonProduct"
        class="product-title__coming-soon-info text-mobile-14-mobile"
        v-text="$string('product.coming_soon.info')"
      />
      <product-prices
        v-else
        :available="product?.available"
        block-class="main-product"
        :compare-at-price="product?.compareAtPrice?.amount"
        :price="product?.price?.amount || liquid.price.amount"
        reverse
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Product title (product-title)
 * -----------------------------------------------------------------------------
 * Product title.
 *
 * @param {Object|Boolean} product - Canvas formatted product object.
 *
 */

import ProductPrices from '~global/product-prices/product-prices'

export default {
  name: 'ProductTitle',

  components: {
    ProductPrices,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        description: '',
        price: 0,
        sectionId: '',
        title: '',
        flatImageBackground: '',
      }),
    },

    comingSoon: {
      type: Object,
      default: () => ({
        contentAvailable: false,
        content: {
          bullets: [],
          text: null,
        },
        listId: null,
        isComingSoonProduct: false,
      }),
    },

    product: {
      type: [Boolean, Object],
      default: false,
    },
  },

  emits: {
  },

  data() {
    return {
    }
  },

  computed: {

    /**
     * Indicates if the current product is a coming soon product.
     */
    comingSoonProduct() {
      return Boolean(this.comingSoon?.isComingSoonProduct)
    },
  },
}
</script>

<style lang="scss">
@import './product-title';
</style>
